import { BaseApi } from "../base-api";
import { AxiosError, AxiosInstance } from "axios";
import { IAudiencesApi, IUpdateAudienceRequestModel } from "@lib/types";

export class AudiencesApi extends BaseApi implements IAudiencesApi {
  constructor(instance: AxiosInstance) {
    super(instance);
  }

  async put(
    account_number: number,
    project_id: number,
    context_id: string,
    requestModel: IUpdateAudienceRequestModel,
  ): Promise<void> {
    try {
      await this._instance.put(
        `/accounts/${account_number}/projects/${project_id}/audiences/${context_id}`,
        requestModel,
      );
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }
}
